import React, { useState, useEffect } from 'react';
import useOnClickOutside from '../../hooks/use-click-outside';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';

export default function ChatAddEmoji(props: {
  onSelect: (emoji: string) => void;
  toggleClasses: string;
  pickerClasses: string;
}) {
  const [showEmojis, setShowEmojis] = useState(false);

  const emojiPickerRef = useOnClickOutside(() => {
    setShowEmojis(false);
  });

  const selectEmoji = (e) => {
    props.onSelect(e.native);
    setShowEmojis(false);
  };

  useEffect(() => {
    const chatShell = document.querySelector('.boxcast-chat--shell') as HTMLElement;
    const skinTone = document.querySelector('.emoji-mart-skin-text') as HTMLElement;
    if (!chatShell) return;
    chatShell.style.overflow = showEmojis === true ? 'visible' : 'hidden';

    if (skinTone) {
      skinTone.innerHTML = 'Skin Tone:';
    }
  }, [showEmojis]);

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          setShowEmojis(true);
        }}
        aria-label="Show Emojis"
        className={props.toggleClasses + (showEmojis ? ' active' : '')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.507 13.941c-1.512 1.195-3.174 1.931-5.506 1.931-2.334 0-3.996-.736-5.508-1.931l-.493.493c1.127 1.72 3.2 3.566 6.001 3.566 2.8 0 4.872-1.846 5.999-3.566l-.493-.493zm-9.007-5.941c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5zm7 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5z" />
        </svg>
      </button>

      {showEmojis && (
        <div className={props.pickerClasses}>
          <div ref={emojiPickerRef}>
            <Picker
              color="#006C80"
              onSelect={selectEmoji}
              native={true}
              set="twitter"
              showSkinTones={true}
              skinEmoji={'+1'}
              showPreview={false}
              theme="light"
              emoji=""
              title=""
            />
          </div>
        </div>
      )}
    </div>
  );
}
